import {Params} from '@angular/router';

export interface StatusPageParams {
    logoUri?: string;
    statusTitle?: string;
    statusContent?: string;
}




export enum StatusTypes {
    UNREGISTER_SUCCESS = 'unregister_success',
    REGISTER_SUCCESS = 'register_success',
    ERROR = 'error',
    ACCOUNT_CANCELLED = "account_cancelled",
    ACCOUNT_LINK_SUCCESSFUL = "account_link_successful"
}
  

const appStatuses: {[key: string]: StatusPageParams } = {    
    
    [StatusTypes.UNREGISTER_SUCCESS]: {
        logoUri: "assets/img/alert-success.svg",
        statusTitle:"STATUS_PAGE.UNREGISTER_SUCCESS.TITLE",
        statusContent:"STATUS_PAGE.UNREGISTER_SUCCESS.CONTENT"
    },
    [StatusTypes.ACCOUNT_CANCELLED]: {
        logoUri: "assets/img/alert-success.svg",
        statusTitle:"STATUS_PAGE.ACCOUNT_CANCELLED.TITLE",
        statusContent:"STATUS_PAGE.ACCOUNT_CANCELLED.CONTENT"
    },
    [StatusTypes.ACCOUNT_LINK_SUCCESSFUL]: {
        logoUri: "assets/img/alert-success.svg",
        statusTitle:"STATUS_PAGE.ACCOUNT_LINK_SUCCESSFUL.TITLE",
        statusContent:"STATUS_PAGE.ACCOUNT_LINK_SUCCESSFUL.CONTENT"
    },
    [StatusTypes.ERROR]:{
        logoUri: "assets/img/sad-face.svg",
        statusTitle:"STATUS_PAGE.ERROR.TITLE",
        statusContent:"STATUS_PAGE.ERROR.CONTENT"  
    }
    }

export const mapParamsToStatusPage = (status: string | null): StatusPageParams => {    

 return status && appStatuses[status] || appStatuses[StatusTypes.ERROR];
};



